import { useEffect, useRef } from "react";
import UnifiedControlPlaneService from "../../UnifiedControlPlane.service";
import "../../UnifiedControlPlane.scss";
import { useDispatch } from "react-redux";

const OrdersThreeDotMenu = ({ item, mission_id, onMenuClose, onDelete, }) => {

  const DELETABLE_ORDER_STATES = ["Complete", "Current", "Executed", "Pending"];

  const dispatch = useDispatch();

  const threeDotMenuRef = useRef();

  const orderUpdateSuccessCallback = () => {
    /**** AT-11751 commented below line as a part of this fix *****/
    // dispatch(UnifiedControlPlaneService.getOrders());
    dispatch(UnifiedControlPlaneService.getCurrentSchedule(mission_id));
  };

  const deleteOrder = () => {
     if (onMenuClose) onMenuClose();
     if (onDelete) onDelete(item.orderId);
    dispatch(UnifiedControlPlaneService.deleteOrders(item.orderId, item?.spec?.name, orderUpdateSuccessCallback));
   
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (threeDotMenuRef.current && !threeDotMenuRef.current.contains(event.target)) {
        onMenuClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onMenuClose]);

  return (
    <div ref={threeDotMenuRef}>
      {item?.status?.state &&
        <div className="threeDotMenuParentDiv">
          <div className="threeDotOptionsMenu">
            <>
              {DELETABLE_ORDER_STATES.includes(item.status.state) && (
                <button
                  className="modalInputBox fullWidth"
                  onClick={deleteOrder}
                >
                  <div className="modalInputBoxText">Delete Order</div>
                </button>
              )}
            </>
          </div>
        </div>
      }
    </div>
  );
};

export default OrdersThreeDotMenu;
